<dx-tab-panel [dataSource]="pages" [selectedIndex]="0">
  <div *dxTemplate="let sheet of 'datasheetTableTemplate'">
    <dx-data-grid [dataSource]="dataSource" [allowColumnReordering]="true" [allowColumnResizing]="true"
                  (onRowRemoving)="onDeleteClicked($event)"
                  (onSaving)="onSaving($event)">
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="MyAccountUsersStateNewUIV2"></dxo-state-storing>
      <dxo-editing mode="popup" refreshMode="full" [selectTextOnEditStart]="true" allowUpdating="canEdit()"
                   [allowDeleting]="true" [allowAdding]="false">
        <dxo-data-grid-popup title="{{ 'Datenblatt' | translate }}" [showTitle]="true"></dxo-data-grid-popup>
        <dxo-form>
          <dxi-item dataField="name"></dxi-item>
        </dxo-form>
      </dxo-editing>
      <dxi-column dataField="name" caption="{{ 'Dateiname' | translate }}"></dxi-column>
    </dx-data-grid>
  </div>
  <div *dxTemplate="let datasheetBackup of 'datasheetBackupTemplate'">
    <dx-data-grid [dataSource]="dataSourceBackups" [allowColumnReordering]="true" [allowColumnResizing]="true">
      <dxi-column dataField="name" caption="{{ 'Backupdatei' | translate }}"></dxi-column>
      <dxi-column type="buttons">
        <dxi-button text="{{ 'Report aus Backup wiederherstellen' | translate }}"
            icon="revert"
            [onClick]="restoreReportFromBackup">
        </dxi-button>
      </dxi-column>
    </dx-data-grid>
  </div>
</dx-tab-panel>
